export enum PaymentMethodType {
  CreditCard = 'CreditCard',
  Cash = 'Cash',
  SquarePOS = 'SquarePOS',
  Alipay = 'Alipay',
  Wechat = 'Wechat',
  Klarna = 'Klarna',
}

export enum CardType {
  Visa = 'visa',
  Mastercard = 'mastercard',
  Amex = 'amex',
  Unknown = 'unknown',
}
